var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * DocumentWarning component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconDocumentWarning extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.79161 2.57007C3.61455 2.57007 3.44475 2.6404 3.31955 2.7656C3.19436 2.8908 3.12402 3.0606 3.12402 3.23765V18.8311C3.12402 19.0081 3.19436 19.1779 3.31955 19.3031C3.44475 19.4283 3.61455 19.4986 3.79161 19.4986H7.15193C7.56615 19.4986 7.90193 19.8344 7.90193 20.2486C7.90193 20.6629 7.56615 20.9986 7.15193 20.9986H3.79161C3.21673 20.9986 2.66539 20.7703 2.25889 20.3638C1.85239 19.9573 1.62402 19.4059 1.62402 18.8311V3.23765C1.62402 2.66277 1.85239 2.11144 2.25889 1.70494C2.66539 1.29844 3.21673 1.07007 3.79161 1.07007H10.8795C11.0784 1.07007 11.2692 1.14909 11.4099 1.28974L18.4978 8.37765C18.6384 8.51831 18.7174 8.70907 18.7174 8.90798V9.23C18.7174 9.64421 18.3817 9.98 17.9674 9.98C17.5532 9.98 17.2174 9.64421 17.2174 9.23V9.21864L10.5689 2.57007H3.79161Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.187 13.0972C16.2018 13.0875 16.2216 13.0811 16.2436 13.0811ZM15.367 11.8411C15.6281 11.6708 15.9332 11.5811 16.2436 11.5811C16.5539 11.5811 16.8592 11.6707 17.1203 11.8413C17.3678 12.0028 17.566 12.2307 17.6897 12.5008L22.1661 20.4762C22.3036 20.7231 22.3766 21.0012 22.3766 21.285C22.3766 21.5657 22.3052 21.8409 22.1705 22.0858C22.0336 22.3425 21.8288 22.5551 21.5804 22.703C21.3296 22.8519 21.0426 22.9302 20.7518 22.9302H11.658C11.3672 22.9302 11.0807 22.8523 10.8299 22.7033C10.5817 22.5555 10.3762 22.3427 10.2393 22.0859C10.1045 21.8407 10.0332 21.5656 10.0332 21.285C10.0332 21.0013 10.106 20.7233 10.2437 20.4762L10.2475 20.4692L14.7989 12.4978C14.9227 12.229 15.1204 12.0021 15.367 11.8411ZM16.2436 13.0811C16.2657 13.0811 16.2855 13.0876 16.3001 13.0971ZM16.3001 13.0971C16.3148 13.1067 16.3229 13.1181 16.3266 13.1269ZM16.187 13.0972C16.1723 13.1068 16.1643 13.1181 16.1605 13.1271C16.1488 13.155 16.1354 13.1822 16.1203 13.2085L11.553 21.2082C11.5395 21.2331 11.5332 21.2594 11.5332 21.285C11.5332 21.3113 11.5399 21.3383 11.5541 21.3639L11.5628 21.3799C11.5687 21.3912 11.5794 21.4038 11.5966 21.414C11.6137 21.4242 11.6347 21.4302 11.658 21.4302H20.7518C20.7751 21.4302 20.7966 21.4239 20.8138 21.4136C20.8308 21.4035 20.841 21.3913 20.847 21.3798L20.8556 21.3639C20.8699 21.3382 20.8766 21.3111 20.8766 21.285C20.8766 21.259 20.87 21.2321 20.856 21.2066L16.3642 13.2037C16.3502 13.1789 16.3377 13.1532 16.3266 13.1269"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16.2109 15.6521C16.6252 15.6521 16.9609 15.9879 16.9609 16.4021V17.6551C16.9609 18.0693 16.6252 18.4051 16.2109 18.4051C15.7967 18.4051 15.4609 18.0693 15.4609 17.6551V16.4021C15.4609 15.9879 15.7967 15.6521 16.2109 15.6521ZM16.2109 19.0391C16.6252 19.0391 16.9609 19.3748 16.9609 19.7891V19.8198C16.9609 20.234 16.6252 20.5698 16.2109 20.5698C15.7967 20.5698 15.4609 20.234 15.4609 19.8198V19.7891C15.4609 19.3748 15.7967 19.0391 16.2109 19.0391Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconDocumentWarning.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentWarning.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconDocumentWarning.prototype, "size", void 0);
if (customElements.get('cat-icon-document-warning') === undefined) {
    customElements.define('cat-icon-document-warning', BlocksIconDocumentWarning);
}
